import { useAppSelector } from 'hooks/redux';
import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import QIllustration from 'components/QIllustration';

const SetupPage = () => {
  const a2AInvestments = useAppSelector((state) =>
    featureFlagsSelectors.getFeatureFlag(state, 'a2AInvestmentAccounts'),
  );

  return (
    <Box textAlign='center' pl={3} pr={3} pt={2} pb={4}>
      <Typography variant='titleMedium'>
        {a2AInvestments
          ? 'Transfer funds to your checking, savings, or investment accounts—all in Simplifi!'
          : 'Transfer funds to your checking or savings accounts—all in Simplifi!'}
      </Typography>
      <Box display='flex' alignItems='center' mt={8} justifyContent='space-between' pl={2} pr={2}>
        <Box display='flex' flexDirection='column' alignItems='center' maxWidth={175}>
          <Box pb={3}>
            <QIllustration name='identityVerification' size='md' />
          </Box>
          <Typography variant='bodyRegular'>Add details so we can verify you&apos;re the account holder</Typography>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center' maxWidth={175}>
          <Box pb={3}>
            <QIllustration name='validationAccount' size='md' />
          </Box>
          <Typography variant='bodyRegular'>Register your accounts to participate in transfers</Typography>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center' maxWidth={175}>
          <Box pb={3}>
            <QIllustration name='transferSavings' size='md' />
          </Box>
          <Typography variant='bodyRegular'>Use Simplifi to transfer funds between your accounts</Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default SetupPage;
